import { Icons, Progress, Typography } from '@agro-club/agroclub-shared'
import { UserContact } from 'modules/domain/userContact/types'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { refetchFunc, useSingleEntity } from 'modules/domain/common/hooks'
import { User } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { AButton } from 'views/components/Analytics'
import { AddContactModal } from './AddContactModal'
import { ContactItem } from './ContactItem'

type Props = {
  setSummary: (arg: number) => void
  userRefetch: refetchFunc
  user: User
}

export const Wrapper = styled.div`
  ${Typography.bodyLarge}
  margin: 1px 0 12px 0;
`

export const Contacts: FC<Props> = ({ user, setSummary, userRefetch }) => {
  const { t } = useTranslation('user')
  const [showModal, setShowModal] = useState<boolean>(false)
  const [progress, contacts = [], refetchContacts] = useSingleEntity<UserContact[]>(endpoints.userContacts(user.id))

  useEffect(() => {
    if (progress === Progress.SUCCESS) setSummary(contacts.length)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts.length])

  const refetch = () => {
    refetchContacts()
    userRefetch()
  }

  return (
    <>
      {!!contacts?.length && (
        <Wrapper>
          {contacts.map((contact) => (
            <ContactItem key={contact.id} contact={contact} refetch={refetch} user={user} />
          ))}
        </Wrapper>
      )}
      {showModal && <AddContactModal refetch={refetch} user={user} setShowModal={() => setShowModal(false)} />}

      <AButton id="addContact" Icon={Icons.IconAdd} color="approve" size="medium" onClick={() => setShowModal(true)}>
        {t('common:add')}
      </AButton>
    </>
  )
}
